import { createContext } from 'react'

import { TourContextValueType } from './TourContext.types'

export const TourContext = createContext<TourContextValueType | undefined>(undefined)
